const purple = '#28336e';

export const colors = {
  qaoPurple: purple,
};



// WEBPACK FOOTER //
// ./src/styles/theme.js